/**
 * @fileoverview PUT handler for the bulk
 * "/companies/:company_id/custom_domains/:domain_type/app_linking_assignments" endpoint.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { putCompaniesCompanyIdCustomDomainsAppLinkingAssignmentsCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdCustomDomainsAppLinkingAssignmentsProps,
  PutCompaniesCompanyIdCustomDomainsAppLinkingAssignmentsResult,
} from "./types";

export const putCompaniesCompanyIdCustomDomainsAppLinkingAssignments = reactQueryMutationAdapter(
  putCompaniesCompanyIdCustomDomainsAppLinkingAssignmentsCacheKeys,
  ({
    companyId,
    domainType,
    configId,
    domains,
  }: PutCompaniesCompanyIdCustomDomainsAppLinkingAssignmentsProps): Promise<PutCompaniesCompanyIdCustomDomainsAppLinkingAssignmentsResult> => {
    // The assignment endpoint reads snake_case params (unlike the config endpoints).
    return fetch(
      `/companies/${companyId}/custom_domains/${domainType}/app_linking_assignments`,
      "PUT",
      {
        config_id: configId,
        domains: domains.map((domain) => ({
          domain_parent_id: domain.domainParentId,
          domain_id: domain.domainId,
          ios_enabled: domain.iosEnabled,
          android_enabled: domain.androidEnabled,
        })),
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
